























































































































































































































import { Vue, Component, Watch, Ref } from 'vue-property-decorator'
import { FindEstoqueUseCase, FindProdutoUseCase } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import {
	ImagensProduto,
	ProdutoVitrineVirtual,
	TipoDeBuscaDaVitrineVirtual,
	VarianteVitrineVirtual,
} from '@/models/Produto'
import { hashColor } from '@/shareds/badge-utils'
import { ItemVitrineVirtual, VitrineVirtualModule } from '@/store/vuex/produto/VitrineVirtualStore'
import DialogoDeSelecionarVariante from '@/components/produto/DialogoDeSelecionarVariante.vue'
import { ProdutoFilho } from '@/models'
import { ItemDaVenda } from '@/models'
import DialogoDeCarrinhoDaVitrineVirtual from './DialogoDeCarrinhoDaVitrineVirtual.vue'
import DialogoDeFiltrosDaVitrineVirtual, {
	FiltrosDaVitrine,
} from '@/views/application/produtos/DialogoDeFiltrosDaVitrineVirtual.vue'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import AplicarTabelaDePrecoUseCase from '@/usecases/tabela-de-precos/AplicarTabelaDePrecoUseCase'

interface PaginaDeVitrineVirtual {
	content: ProdutoVitrineVirtual[]
	last: boolean
	totalElements?: number
	totalPages?: number
	number?: number
}

interface SelecaoVariante {
	cor: string | null
	tamanho: string | null
}

@Component({
	components: {
		DialogoDeFiltrosDaVitrineVirtual,
		DialogoDeSelecionarVariante,
		DialogoDeCarrinhoDaVitrineVirtual,
	},
})
export default class DialogoDeVitrineVirtual extends Vue {
	@Ref() dialogoDeSelecionarVariante!: DialogoDeSelecionarVariante
	@Ref() dialogoDoCarrinhoDaVitrineVirtual!: DialogoDeCarrinhoDaVitrineVirtual
	@Ref() dialogoDeFiltrosDaVitrineVirtual!: DialogoDeFiltrosDaVitrineVirtual
	@Ref() campoDeBusca!: { focus: () => void }

	filtroAplicado: FiltrosDaVitrine | null = null
	findProdutoUseCase = new FindProdutoUseCase()
	findEstoqueUseCase = new FindEstoqueUseCase()
	mostra = false
	busca = ''

	produtos: ProdutoVitrineVirtual[] = []
	produtosOriginais: ProdutoVitrineVirtual[] = []
	categorias: string[] = []

	carregando = false
	produtoCarregandoId: string | null = null
	categoriaSelecionada: string | null = null
	lojaId = ''
	tipoDeBusca: TipoDeBuscaDaVitrineVirtual = 'REFERENCIA'
	buscaRealizada = false
	imagemPadrao = 'https://i.pinimg.com/originals/61/3c/ea/613ceaae3543acdf381af20da47612dc.png'

	selecoesPorProduto: Record<string, SelecaoVariante> = {}

	get vendaAtual() {
		return VendaModule.vendaAtual
	}

	get lojaDaVenda() {
		return VendaModule.lojaDaVenda
	}

	async mostrar(lojaId: string, tipoDeBusca: TipoDeBuscaDaVitrineVirtual) {
		this.mostra = true
		this.lojaId = lojaId
		this.tipoDeBusca = tipoDeBusca
		this.buscaRealizada = false
		this.busca = ''
		this.produtos = []
		this.produtosOriginais = []
		this.categorias = []
		await this.$nextTick()
		requestAnimationFrame(() => {
			this.campoDeBusca?.focus()
		})
	}

	get placeholderDaBusca(): string {
		return this.tipoDeBusca === 'VARIANTE'
			? 'Bipe o código de barras do produto'
			: 'Informe a referência do produto'
	}

	get mensagemDaListaVazia(): string {
		return this.buscaRealizada ? 'Nenhum produto encontrado.' : this.placeholderDaBusca
	}

	fechar() {
		this.mostra = false
		this.busca = ''
		this.limparFiltros()
	}

	@Watch('categoriaSelecionada')
	onCategoriaChange() {
		if (!this.mostra) return
		this.aplicarFiltrosLocais()
	}

	async buscarPorCodigo() {
		const codigo = (this.busca ?? '').trim()
		if (!codigo) return AlertModule.setError(this.placeholderDaBusca)

		this.carregando = true
		this.produtos = []
		this.produtosOriginais = []
		this.categoriaSelecionada = null
		this.filtroAplicado = null

		try {
			const produtosBrutos: ProdutoVitrineVirtual[] =
            await this.findEstoqueUseCase.consultaEstoqueDaVitrineVirtual(this.lojaId, codigo, this.tipoDeBusca)

			const produtosEncontrados = await this.aplicarTabelaDePrecoNosProdutos(produtosBrutos)

			this.produtosOriginais = produtosEncontrados
			this.preSelecionarVariantes(produtosEncontrados)
			this.aplicarFiltrosLocais()
			this.atualizarCategorias(produtosEncontrados, true)
			this.buscaRealizada = true

			if (!produtosEncontrados.length) {
				AlertModule.setError('Sem estoque disponível na vitrine virtual')
			}
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	preSelecionarVariantes(produtos: ProdutoVitrineVirtual[]) {
		produtos.forEach(produto => {
			const variantes = produto.variantesDisponiveis ?? []
			if (!variantes.length) return
			if (this.selecoesPorProduto[produto.id]) return

			const primeiraDisponivel = variantes.find(v => v.estoqueDisponivel > 0)
			if (!primeiraDisponivel) return

			this.$set(this.selecoesPorProduto, produto.id, {
				cor: primeiraDisponivel.cor ?? null,
				tamanho: primeiraDisponivel.tamanho ?? null,
			})
		})
	}

	atualizarCategorias(produtos: ProdutoVitrineVirtual[], resetar: boolean) {
		const base = resetar ? [] : [...this.categorias]
		produtos.forEach(p => {
			if (p.categoriaNome && !base.includes(p.categoriaNome)) {
				base.push(p.categoriaNome)
			}
		})
		this.categorias = base.sort((a, b) => a.localeCompare(b))
	}

	tamanhosDoProduto(produto: ProdutoVitrineVirtual): string[] {
		const variantes = produto.variantesDisponiveis
		if (!variantes?.length) return produto.tamanhos ?? []
		return [
			...new Set(
				variantes
					.filter(v => v.estoqueDisponivel > 0)
					.map(v => v.tamanho)
					.filter((t): t is string => !!t),
			),
		]
	}

	coresDoProduto(produto: ProdutoVitrineVirtual): string[] {
		const variantes = produto.variantesDisponiveis
		if (!variantes?.length) return produto.cores ?? []
		return [
			...new Set(
				variantes
					.filter(v => v.estoqueDisponivel > 0)
					.map(v => v.cor)
					.filter((c): c is string => !!c),
			),
		]
	}

	tamanhoSelecionadoPor(produtoId: string): string | null {
		return this.selecoesPorProduto[produtoId]?.tamanho ?? null
	}

	corSelecionadaPor(produtoId: string): string | null {
		return this.selecoesPorProduto[produtoId]?.cor ?? null
	}

	tamanhoTemEstoque(produto: ProdutoVitrineVirtual, tamanho: string): boolean {
		if (!produto.variantesDisponiveis?.length) return true
		return produto.variantesDisponiveis.some(
			v => v.tamanho === tamanho && v.estoqueDisponivel > 0,
		)
	}

	tooltipDaCor(produto: ProdutoVitrineVirtual, cor: string): string {
		if (this.corTemEstoque(produto, cor)) return cor

		const tamanhoAtual = this.tamanhoSelecionadoPor(produto.id)
		if (!tamanhoAtual) return `${cor} · sem estoque`

		return `${cor} · sem estoque no tamanho ${tamanhoAtual}`
	}

	corTemEstoque(produto: ProdutoVitrineVirtual, cor: string): boolean {
		if (!produto.variantesDisponiveis?.length) return true
		const tamanhoAtual = this.tamanhoSelecionadoPor(produto.id)
		return produto.variantesDisponiveis.some(
			v =>
				v.cor === cor &&
				v.estoqueDisponivel > 0 &&
				(!tamanhoAtual || v.tamanho === tamanhoAtual),
		)
	}

	selecionarTamanho(produtoId: string, tamanho: string) {
		const produto = this.produtos.find(p => p.id === produtoId)
		if (!produto) return

		const atual = this.selecoesPorProduto[produtoId] ?? { cor: null, tamanho: null }
		const novoTamanho = atual.tamanho === tamanho ? atual.tamanho : tamanho 

		const corAtualValida = atual.cor && produto.variantesDisponiveis?.some(
        v => v.tamanho === novoTamanho && v.cor === atual.cor && v.estoqueDisponivel > 0
    )

		const novaCor = corAtualValida
			? atual.cor
			: produto.variantesDisponiveis?.find(
            v => v.tamanho === novoTamanho && v.estoqueDisponivel > 0
        )?.cor ?? atual.cor

		this.$set(this.selecoesPorProduto, produtoId, {
			tamanho: novoTamanho,
			cor: novaCor ?? null,
		})
	}

	selecionarCor(produtoId: string, cor: string) {
		const produto = this.produtos.find(p => p.id === produtoId)
		if (!produto) return
		if (!this.corTemEstoque(produto, cor)) return

		const atual = this.selecoesPorProduto[produtoId] ?? { cor: null, tamanho: null }
		const novaCor = atual.cor === cor ? atual.cor : cor

		const tamanhoAtualValido = atual.tamanho && produto.variantesDisponiveis?.some(
        v => v.cor === novaCor && v.tamanho === atual.tamanho && v.estoqueDisponivel > 0
    )

		const novoTamanho = tamanhoAtualValido
			? atual.tamanho
			: produto.variantesDisponiveis?.find(
            v => v.cor === novaCor && v.estoqueDisponivel > 0
        )?.tamanho ?? atual.tamanho

		this.$set(this.selecoesPorProduto, produtoId, {
			cor: novaCor ?? null,
			tamanho: novoTamanho ?? null,
		})
	}

	async selecionarProduto(produtoSelecionado: ProdutoVitrineVirtual) {
		if (this.produtoCarregandoId) return
		this.produtoCarregandoId = produtoSelecionado.id

		try {
			const variantes: VarianteVitrineVirtual[] = produtoSelecionado.variantesDisponiveis ?? []

			if (!variantes.length) {
				this.adicionarProdutoAoCarrinho(produtoSelecionado as any, produtoSelecionado.preco)
				return
			}

			const selecao = this.selecoesPorProduto[produtoSelecionado.id]
			const temCores = this.coresDoProduto(produtoSelecionado).length > 0
			const temTamanhos = this.tamanhosDoProduto(produtoSelecionado).length > 0

			const corOk = !temCores || !!selecao?.cor
			const tamanhoOk = !temTamanhos || !!selecao?.tamanho

			if (!corOk || !tamanhoOk) {
				AlertModule.setError(
					!corOk && !tamanhoOk ? 'Selecione a cor e o tamanho antes de adicionar.'
						: !corOk ? 'Selecione a cor antes de adicionar.'
							: 'Selecione o tamanho antes de adicionar.',
				)
				return
			}

			const varianteEncontrada = variantes.find(v => {
				const corOk = !selecao?.cor || v.cor === selecao.cor
				const tamanhoOk = !selecao?.tamanho || v.tamanho === selecao.tamanho
				return corOk && tamanhoOk && v.estoqueDisponivel > 0
			})

			if (!varianteEncontrada) {
				AlertModule.setError('Combinação de cor/tamanho sem estoque disponível.')
				return
			}

			const precoComTabela = (varianteEncontrada as any).preco ?? produtoSelecionado.preco ?? 0

			const produtoParaCarrinho: ProdutoFilho = {
				id: varianteEncontrada.id,
				nome: varianteEncontrada.nome ?? produtoSelecionado.nome,
				sku: varianteEncontrada.sku ?? produtoSelecionado.sku,
				preco: Number(precoComTabela),
				urlImagens: produtoSelecionado.urlImagens ?? null,
				categoriaNome: produtoSelecionado.categoriaNome,
				produtoDesativado: produtoSelecionado.produtoDesativado,
			} as any

			this.adicionarProdutoAoCarrinho(produtoParaCarrinho, Number(precoComTabela))

		} catch (error) {
			AlertModule.setError('Erro ao buscar detalhes do produto.')
		} finally {
			this.produtoCarregandoId = null
		}
	}

	adicionarProdutoAoCarrinho(produto: ProdutoFilho | null, precoComTabela?: number) {
		if (!produto) return

		const preco = precoComTabela ?? (produto as any).preco ?? 0

		const produtoDaVitrine: ProdutoVitrineVirtual = {
			id: produto.id,
			nome: produto.nome ?? '',
			sku: produto.sku ?? '',
			categoriaNome: (produto as any).categoriaNome ?? '',
			produtoDesativado: (produto as any).produtoDesativado ?? false,
			urlImagens: (produto as any).urlImagens ?? null,
			preco,
			tamanhos: (produto as any).tamanhos ?? [],
			cores: (produto as any).cores ?? [],
			variantesDisponiveis: (produto as any).variantesDisponiveis ?? [],
		}

		const itensAtualizados = [...this.produtosSelecionados]
		const indiceExistente = itensAtualizados.findIndex(
			item => item.produto.id === produtoDaVitrine.id,
		)

		if (indiceExistente >= 0) {
			itensAtualizados[indiceExistente].quantidade += 1
		} else {
			itensAtualizados.push({ produto: produtoDaVitrine, quantidade: 1 })
		}

		VitrineVirtualModule.setDados({ produtos: itensAtualizados })

		AlertModule.setSuccess('Item adicionado ao carrinho da vitrine')
	}

	get produtosSelecionados(): ItemVitrineVirtual[] {
		return VitrineVirtualModule.dados.produtos ?? []
	}

	get quantidadeTotalNoCarrinho(): number {
		return this.produtosSelecionados.reduce(
			(total, item) => total + (item.quantidade ?? 0),
			0,
		)
	}

	obterQuantidadeSelecionada(produtoId: string): number {
		return (
			this.produtosSelecionados.find(i => i.produto.id === produtoId)?.quantidade ?? 0
		)
	}

	produtoEstaSelecionado(produtoId: string): boolean {
		return this.obterQuantidadeSelecionada(produtoId) > 0
	}

	abrirResumoDoCarrinho() {
		this.dialogoDoCarrinhoDaVitrineVirtual.mostrar()
	}

	async finalizarCarrinho(itens: ItemVitrineVirtual[]) {
		if (!itens?.length) {
			this.dialogoDoCarrinhoDaVitrineVirtual.fechar()
			return
		}

		this.$emit('carregando', true)

		try {
			const skusSemEstoque = await this.findEstoqueUseCase.buscarSkusSemEstoqueNaVitrineVirtual(
				this.lojaId,
				this.montarQuantidadePorSku(itens),
			)

			skusSemEstoque.forEach(sku =>
				AlertModule.setError("Item não possui estoque em vitrine virtual o suficiente para venda. SKU: " + sku),
			)

			itens
				.filter(item => !skusSemEstoque.includes(item.produto.sku))
				.forEach(item => this.$emit('input', this.criarItemDaVenda(item.produto, item.quantidade)))
		} finally {
			this.$emit('carregando', false)
			this.dialogoDoCarrinhoDaVitrineVirtual.fechar()
		}

		VitrineVirtualModule.resetar()
		this.fechar()
	}

	montarQuantidadePorSku(itens: ItemVitrineVirtual[]): Record<string, number> {
		return itens.reduce((quantidadePorSku, item) => ({
			...quantidadePorSku,
			[item.produto.sku]: (quantidadePorSku[item.produto.sku] ?? 0) + item.quantidade,
		}), {} as Record<string, number>)
	}

	criarItemDaVenda(produto: ProdutoVitrineVirtual, quantidade: number): ItemDaVenda {
		const preco = Number(produto.preco ?? 0) 
		return {
			preco,
			produto: {
				id: produto.id,
				nome: produto.nome,
				sku: produto.sku,
				urlImagens: produto.urlImagens,
				preco, 
			} as any,
			id: '',
			quantidade,
			quantidadeLida: 0,
			desconto: { isPercentual: true, valor: 0.0 },
			precoDeCusto: 0,
			idConjunto: null,
			descontoVarejo: 0,
			percentualCashback: 0,
			diasParaEfetivarCashback: 0,
			isBrinde: false,
			idItemNotaOrigem: null,
			chaveNotaOrigem: null,
			diasParaExpirarCashback: 0,
			possuiDescontoPorTabela: false,
			valorDescontoRateadoDoItem: 0,
			itemDeDevolucao: false,
			isTotalmenteTrocado: false,
			motivoCancelamento: null,
			isCompra: false,
			idItemOrigem: '',
			isDaVendaReaberta: false,
			vendedor: null,
			autenticadoParaLiberarProdutoSemEstoque: false,
			vendaOrigemDoItem: null,
			valorFreteRateado: 0,
			isItemReferenteATroca: false,
			isDeOutraLoja: false,
			percentualDescontoTabelaPreco: 0,
			precoDeCustoReal: 0,
			selecionadoViaVitrineVirtual: true,
			skuPai: null,
		}
	}

	abrirDialogoDeFiltrosDeVitrineVirtual() {
		this.dialogoDeFiltrosDaVitrineVirtual.mostrar()
	}

	selecionarCategoria(categoria: string, toggle?: () => void) {
		this.categoriaSelecionada =
			this.categoriaSelecionada === categoria ? null : categoria
		toggle?.()
		this.aplicarFiltrosLocais()
	}

	async limparFiltros() {
		this.categoriaSelecionada = null
		this.filtroAplicado = null
		this.aplicarFiltrosLocais()
	}

	hashColor = hashColor

	aplicarFiltros(filtros: FiltrosDaVitrine) {
		this.filtroAplicado = filtros
		this.aplicarFiltrosLocais()
	}

	// FOI SOLICITADO QUE DEIXASSE PREPARADO PARA APLICAR O FILTRO EM CIMA DO QUE TIVER SIDO
	// BUSCADO AO INVÉS DE BUSCAR NOVAMENTE NO BACKEND
	aplicarFiltrosLocais() {
		let lista = [...this.produtosOriginais]

		if (this.categoriaSelecionada) {
			const cat = this.categoriaSelecionada.toLowerCase().trim()
			lista = lista.filter(p =>
				(p.categoriaNome ?? '').toLowerCase().includes(cat) ||
			(p.variantesDisponiveis ?? []).some(v =>
				(v.categoria ?? '').toLowerCase().includes(cat),
			),
			)
		}

		if (this.filtroAplicado?.tamanho) {
			const t = this.filtroAplicado.tamanho.toLowerCase().trim()
			lista = lista.filter(p =>
				(p.variantesDisponiveis ?? []).some(v =>
					(v.tamanho ?? '').toLowerCase().includes(t),
				) ||
			(p.tamanhos ?? []).some(i => String(i).toLowerCase().includes(t)),
			)
		}

		if (this.filtroAplicado?.cor) {
			const c = this.filtroAplicado.cor.toLowerCase().trim()
			lista = lista.filter(p =>
				(p.variantesDisponiveis ?? []).some(v =>
					(v.cor ?? '').toLowerCase().includes(c),
				) ||
			(p.cores ?? []).some(i => String(i).toLowerCase().includes(c)),
			)
		}

		if (this.filtroAplicado?.categoria) {
			const cat = this.filtroAplicado.categoria.toLowerCase().trim()
			lista = lista.filter(p =>
				(p.categoriaNome ?? '').toLowerCase().includes(cat) ||
			(p.variantesDisponiveis ?? []).some(v =>
				(v.categoria ?? '').toLowerCase().includes(cat),
			),
			)
		}

		if (this.filtroAplicado?.genero) {
			const g = this.filtroAplicado.genero.nome.toLowerCase().trim()
			lista = lista.filter(p =>
				(p.variantesDisponiveis ?? []).some(v =>
					(v.genero ?? '').toLowerCase().includes(g),
				),
			)
		}

		if (this.filtroAplicado?.estacao) {
			const e = this.filtroAplicado.estacao.nome.toLowerCase().trim()
			lista = lista.filter(p =>
				(p.variantesDisponiveis ?? []).some(v =>
					(v.estacao ?? '').toLowerCase().includes(e),
				),
			)
		}

		if (this.filtroAplicado?.produtoSimilar) {
			const ps = this.filtroAplicado.produtoSimilar.toLowerCase().trim()
			lista = lista.filter(
				p =>
					(p.nome ?? '').toLowerCase().includes(ps) ||
				(p.variantesDisponiveis ?? []).some(v =>
					(v.sku ?? '').toLowerCase().includes(ps) ||
					(v.cor ?? '').toLowerCase().includes(ps) ||
					(v.tamanho ?? '').toLowerCase().includes(ps) ||
					(v.genero ?? '').toLowerCase().includes(ps) ||
					(v.categoria ?? '').toLowerCase().includes(ps) ||
					(v.estacao ?? '').toLowerCase().includes(ps),
				),
			)
		}

		this.produtos = lista
	}

	produtoEstaCarregando(produtoId: string): boolean {
		return this.produtoCarregandoId === produtoId
	}

	substituirPelaImagemPadrao(evento: Event) {
		const imagem = evento.target as HTMLImageElement
		if (imagem.src === this.imagemPadrao) return
		imagem.src = this.imagemPadrao
	}

	getImagemProduto(produto: ProdutoVitrineVirtual): string {
		const getUrlFromImagens = (urlImagens: ImagensProduto[] | any): string | null => {
			if (!urlImagens) return null

			if (typeof urlImagens === 'string') return urlImagens

			if (Array.isArray(urlImagens) && urlImagens.length) {
				const padrao = urlImagens.find((img: ImagensProduto) => img.padrao === true)
				const imagem = padrao || urlImagens[0]
				if (imagem?.imagemUrl) return imagem.imagemUrl
			}

			return null
		}

		const imagemDoProduto = getUrlFromImagens(produto.urlImagens)
		if (imagemDoProduto) return imagemDoProduto

		const imagemDaVariante = (produto.variantesDisponiveis ?? [])
			.map(variante => getUrlFromImagens(variante.urlImagens))
			.find(url => !!url)

		return imagemDaVariante || this.imagemPadrao
	}

	get isDark(): boolean {
		return this.$vuetify.theme.dark
	}

	deveMostrarTooltip(texto: string): boolean {
		return !!texto && texto.length > 55
	}

	formatarPreco(preco: number): string {
		return new Intl.NumberFormat('pt-BR', {
			style: 'currency',
			currency: 'BRL',
		}).format(preco)
	}

	normalizarCor(cor: string): string {
		const mapa: Record<string, string> = {
			preto: '#000000',
			branco: '#ffffff',
			azul: '#1e3a8a',
			vermelho: '#dc2626',
			verde: '#16a34a',
			amarelo: '#facc15',
			cinza: '#6b7280',
			bege: '#d6c2a1',
			marrom: '#7c4a21',
			rosa: '#ec4899',
			roxo: '#7c3aed',
			laranja: '#f97316',
			offwhite: '#f5f5f0',
			'off-white': '#f5f5f0',
			creme: '#f3e7d3',
		}
		if (!cor) return '#f3e7d3'
		return mapa[cor.toLowerCase().trim()] ?? cor
	}

	async aplicarTabelaDePrecoNosProdutos(
		produtos: ProdutoVitrineVirtual[],
	): Promise<ProdutoVitrineVirtual[]> {
		if (!produtos.length) return produtos
		const turnoDeVenda = JSON.parse(localStorage.getItem('TURNO_DE_VENDA_STORAGE') || 'null')
		if (!turnoDeVenda) {
			AlertModule.setError("Validar turno de venda para aplicar tabela de preço") 
			return produtos
		}
		const tabelaDePreco = turnoDeVenda.pontoDeVenda.tabelaDePreco

		const vendaAtual = this.vendaAtual
		const lojaDaVenda = this.lojaDaVenda

		if (!vendaAtual || !lojaDaVenda) return produtos
		const tipoDeCliente = vendaAtual.tipoDeCliente ?? null

		try {
			const itensProdutos: ItemDaVenda[] = produtos.map(produto => ({
				id: '',
				produto: {
					id: produto.id,
					nome: produto.nome,
					sku: produto.sku,
					urlImagens: produto.urlImagens,
					preco: Number(produto.preco ?? 0),
				} as any,
				quantidade: 1,
				quantidadeLida: 0,
				desconto: { isPercentual: true, valor: 0.0 },
				preco: Number(produto.preco ?? 0),
				precoDeCusto: 0,
				idConjunto: null,
				descontoVarejo: 0,
				percentualCashback: 0,
				diasParaEfetivarCashback: 0,
				isBrinde: false,
				idItemNotaOrigem: null,
				chaveNotaOrigem: null,
				diasParaExpirarCashback: 0,
				possuiDescontoPorTabela: false,
				valorDescontoRateadoDoItem: 0,
				itemDeDevolucao: false,
				isTotalmenteTrocado: false,
				motivoCancelamento: null,
				isCompra: false,
				idItemOrigem: '',
				isDaVendaReaberta: false,
				vendedor: null,
				autenticadoParaLiberarProdutoSemEstoque: false,
				vendaOrigemDoItem: null,
				valorFreteRateado: 0,
				isItemReferenteATroca: false,
				isDeOutraLoja: false,
				percentualDescontoTabelaPreco: 0,
				precoDeCustoReal: 0,
				selecionadoViaVitrineVirtual: true,
				skuPai: null,
			}))

			const variantesFlat = produtos.flatMap(produto =>
				(produto.variantesDisponiveis ?? []).map(variante => ({
					produtoPaiId: produto.id,
					variante,
				})),
			)

			const itensVariantes: ItemDaVenda[] = variantesFlat.map(({ variante }) => ({
				id: '',
				produto: {
					id: variante.id,
					nome: variante.nome ?? '',
					sku: variante.sku ?? '',
					urlImagens: (variante as any).urlImagens ?? null,
					preco: Number((variante as any).preco ?? 0),
				} as any,
				quantidade: 1,
				quantidadeLida: 0,
				desconto: { isPercentual: true, valor: 0.0 },
				preco: Number((variante as any).preco ?? 0),
				precoDeCusto: 0,
				idConjunto: null,
				descontoVarejo: 0,
				percentualCashback: 0,
				diasParaEfetivarCashback: 0,
				isBrinde: false,
				idItemNotaOrigem: null,
				chaveNotaOrigem: null,
				diasParaExpirarCashback: 0,
				possuiDescontoPorTabela: false,
				valorDescontoRateadoDoItem: 0,
				itemDeDevolucao: false,
				isTotalmenteTrocado: false,
				motivoCancelamento: null,
				isCompra: false,
				idItemOrigem: '',
				isDaVendaReaberta: false,
				vendedor: null,
				autenticadoParaLiberarProdutoSemEstoque: false,
				vendaOrigemDoItem: null,
				valorFreteRateado: 0,
				isItemReferenteATroca: false,
				isDeOutraLoja: false,
				percentualDescontoTabelaPreco: 0,
				precoDeCustoReal: 0,
				selecionadoViaVitrineVirtual: true,
				skuPai: null,
			}))

			const [itensProdutosComPreco, itensVariantesComPreco] = await Promise.all([
				Promise.all(
					itensProdutos.map(item =>
						AplicarTabelaDePrecoUseCase({
							loja: lojaDaVenda,
							itens: [item],
							tipoDeCliente,
							validarLimiteDeProduto: false,
							vendaAtual: vendaAtual,
							tabelaDePreco: tabelaDePreco,
						})
							.then(resultado => resultado[0])
							.catch(() => item), 
					),
				),
				Promise.all(
					itensVariantes.map(item =>
						AplicarTabelaDePrecoUseCase({
							loja: lojaDaVenda,
							itens: [item],
							tipoDeCliente,
							validarLimiteDeProduto: false,
							vendaAtual: vendaAtual,
							tabelaDePreco: tabelaDePreco || undefined,
						})
							.then(resultado => resultado[0])
							.catch(() => item),
					),
				),
			])

			const precoProdutoPorId = new Map<string, number>(
				itensProdutosComPreco.map(item => [item.produto.id, Number(item.preco ?? 0)]),
			)

			const precoVariantePorId = new Map<string, number>(
				itensVariantesComPreco.map(item => [item.produto.id, Number(item.preco ?? 0)]),
			)

			return produtos.map((produto): ProdutoVitrineVirtual => ({
				...produto,
				preco: precoProdutoPorId.get(produto.id) ?? Number(produto.preco ?? 0),
				variantesDisponiveis: (produto.variantesDisponiveis ?? []).map(variante => ({
					...variante,
					preco: precoVariantePorId.get(variante.id) ?? Number((variante as any).preco ?? 0),
				})),
			}))
		} catch (error) {
			AlertModule.setError('Erro ao aplicar tabela de preço na vitrine.')
			return produtos
		}
	}

	obterVarianteSelecionada(produto: ProdutoVitrineVirtual): VarianteVitrineVirtual | null {
		const variantes = produto.variantesDisponiveis ?? []
		if (!variantes.length) return null

		const selecao = this.selecoesPorProduto[produto.id]
		if (!selecao?.cor && !selecao?.tamanho) return null

		return (
			variantes.find(v => {
				const corOk = !selecao?.cor || v.cor === selecao.cor
				const tamanhoOk = !selecao?.tamanho || v.tamanho === selecao.tamanho
				return corOk && tamanhoOk
			}) ?? null
		)
	}

	obterPrecoExibido(produto: ProdutoVitrineVirtual): number {
		const varianteSelecionada = this.obterVarianteSelecionada(produto)

		if (varianteSelecionada && varianteSelecionada.preco !== null && varianteSelecionada.preco !== undefined) {
			return Number(varianteSelecionada.preco)
		}

		return Number(produto.preco ?? 0)
	}

	obterCorExibida(produto: ProdutoVitrineVirtual, nomeCor: string): string {
		const variante = produto.variantesDisponiveis?.find(
        v => v.cor === nomeCor && v.codigoCor
    )

		if (variante?.codigoCor) return variante.codigoCor

		return this.normalizarCor(nomeCor)
	}
}
